import api from '../../../../api';
import {
  CreateCanvasAssetRequest,
  CreateCanvasAssetResponse,
} from '@dreamai/types';

interface CreateCompanyCanvasAssetParams {
  companyId: number;
  companyName: string;
  threadId: string;
  getAccessTokenSilently: () => Promise<string>;
}

export const createCompanyCanvasAsset = async ({
  companyId,
  companyName,
  threadId,
  getAccessTokenSilently,
}: CreateCompanyCanvasAssetParams): Promise<void> => {
  try {
    const token = await getAccessTokenSilently();
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    const createRequest: CreateCanvasAssetRequest = {
      threadId: threadId,
      title: `Company: ${companyName}`,
      components: [
        {
          type: 'CompanyCRMView',
          props: {
            companyId: String(companyId),
          },
          order: 1,
        },
      ],
    };

    const response = await api.post('/canvas-assets', createRequest);
    const data: CreateCanvasAssetResponse = response.data;

    if (data.success) {
      console.log(
        'Canvas asset created successfully:',
        data.asset?.canvasAssetId,
      );
      // The canvas system will automatically switch to the new asset via pusher events
    } else {
      console.error('Failed to create canvas asset:', data.error);
    }
  } catch (err) {
    console.error('Error creating canvas asset for company:', err);
  }
};
